export default __webpack_public_path__ + "static/media/IconMe.914f4adc.svg";